export * from '@primeuix/themes/lara/togglebutton';
export { default } from '@primeuix/themes/lara/togglebutton';
